import React from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import HeaderOne from "../components/HeaderOne";
import FooterOne from "../components/FooterOne";
import Modal from "../components/Modal";
import EbookForm from "../components/EbookForm";
import GetDemoForm from "../components/GetDemoForm";
import CalendlyModal from "../components/CalendlyModal";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import TerminalDetails from "../components/TerminalDetails";
import Login from "../components/Login";
import Register from "../components/Register";
import VerifyEmail from "../components/VerifyEmail";
import ForgotPassword from "../components/ForgotPassword";

const MasterLayout = ({
  openEbookModal,
  setOpenEbookModal,
  openGetDemoModal,
  setOpenGetDemoModal,
  openLoginModal,
  setOpenLoginModal,
  openRegisterModal,
  setOpenRegisterModal,
  openForgotPasswordModal,
  setOpenForgotPasswordModal,
  openVerifyEmailModal,
  setOpenVerifyEmailModal,
  verificationEmail,
  setVerificationEmail,
  openCalendlyModal,
  setOpenCalendlyModal,
  closeModal, // from useModals
  isModalOpen,
  handleCloseModal,
  selectedCard,
}) => {
  const { i18n, t } = useTranslation();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  return (
    <>

      <Helmet>
        <html lang={i18n.language} />
        <title>{t("meta.title")}</title>
        <meta name="description" content={t("meta.description")} />
        <meta name="keywords" content={t("meta.keywords")} />
      </Helmet>

      {/* Header */}
      <HeaderOne
        setOpenGetDemoModal={setOpenGetDemoModal}
        setOpenLoginModal={setOpenLoginModal}
        setOpenRegisterModal={setOpenRegisterModal}
        isAuthenticated={isAuthenticated}
      />

      {/* Page Content */}
      <Outlet />

      {/* Footer */}
      <FooterOne />

      {/* Modals */}
      <Modal
        isOpen={openEbookModal}
        onClose={() => closeModal("ebook")}
        title={t('becomeSellerTwo.ebookModal.title')}
      >
        <EbookForm />
      </Modal>

      <Modal
        isOpen={openGetDemoModal}
        onClose={() => closeModal("getDemo")}
        title={t('getDemoForm.title')}
      >
        <GetDemoForm />
      </Modal>

      <Modal
        isOpen={openCalendlyModal}
        onClose={() => closeModal("calendly")}
      >
        <CalendlyModal />
      </Modal>

      <Modal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        withoutLogo
      >
        <TerminalDetails selectedCard={selectedCard} />
      </Modal>
      <Modal
        isOpen={openLoginModal}
        onClose={() => closeModal("login")}
        withoutLogo
      >
        <Login
          setOpenLoginModal={setOpenLoginModal}
          setOpenRegisterModal={setOpenRegisterModal}
          setOpenForgotPasswordModal={setOpenForgotPasswordModal}
        />
      </Modal>
      <Modal
        isOpen={openRegisterModal}
        onClose={() => closeModal("register")}
        withoutLogo
      >
        <Register
          setOpenLoginModal={setOpenLoginModal}
          setOpenRegisterModal={setOpenRegisterModal}
          setOpenVerifyEmailModal={setOpenVerifyEmailModal}
          setVerificationEmail={setVerificationEmail}
        />
      </Modal>
      <Modal isOpen={openForgotPasswordModal} onClose={() => setOpenForgotPasswordModal(false)} large withoutLogo>
        <ForgotPassword setOpenForgotPasswordModal={setOpenForgotPasswordModal} setOpenLoginModal={setOpenLoginModal} />
      </Modal>
      <Modal
        isOpen={openVerifyEmailModal}
        onClose={() => setOpenVerifyEmailModal(false)}
        withoutLogo
      >
        <VerifyEmail
          email={verificationEmail}
          setOpenVerifyEmailModal={setOpenVerifyEmailModal}
          setOpenLoginModal={setOpenLoginModal}
        />
      </Modal>
    </>
  );
};

export default MasterLayout;
